<!-- 设置模板 -->
<template>
    <div class="inputPopup" v-clickoutside = '_handlerClose'>
        <div class="inputwrap">
            <input type = "text" @click.stop = '!popupShowFlag ? popupShowFlag = true : popupShowFlag = false' @mouseover = "closedShowFlag = true" @mouseleave = "closedShowFlag = false" :placeholder = 'placeholder' v-model = 'inputTitle' readonly>
            <i class = 'iconfont icon-xia falgs' @mouseover = "closedShowFlag = true" ></i>
            <img :src = "popup_close" class = 'clears' alt="" @click.stop = '_clearData' v-show = 'valueArr.length > 0'>
        </div>
        <div class="detail_fill"></div>
        <div class = 'popwrap' v-if = 'popupShowFlag'>
            <!-- 显示部分 -->
            <div class = "mtsi-4-block">
                <div class = 'mtsi-4-content clearfloat'
                    :class = '[Number(lineNum) === 1 ? "mtsi-4-content_w1" : Number(lineNum) === 2 ? "mtsi-4-content_w2" : twoMenu.length > 0 ? "mtsi-4-content_w3" : "mtsi-4-content_w2"]'>
                    <div class="mtsi-4-content-left">
                        <ul>
                            <li v-for = 'item in propInfo' :key = 'item.value'>
                                <span
                                    :class = '[valueArrChoosed[0] === item.value ? "gaoliang" : ""]'
                                    @click.stop = '_oneMenuClickHandler(item.value, item.label, item.children)'
                                >{{item.label}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="mtsi-4-content-right zwlbzhong" v-if = 'Number(lineNum) >= 2'>
                        <div class="xuanze_div" v-show = 'twoMenu.length === 0'>
                            <img :src = "xuanze" alt="">
                            <span>{{placeholder}}</span>
                        </div>
                        <ul>
                            <li v-for = 'item in twoMenu' :key = 'item.value'>
                                <span
                                :class = '[valueArrChoosed[1] === item.value ? "gaoliang" : ""]'
                                @click.stop = '_twoMenuClickHandler(item.value, item.label, item.children)'
                                >{{item.label}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="mtsi-4-content-right zwlbyou" v-if = 'Number(lineNum) >= 3 && twoMenu.length > 0'>
                        <div class="xuanze_div" v-show = 'threeMenu.length === 0'>
                            <img :src = "xuanze" alt="">
                            <span>{{placeholder}}</span>
                        </div>
                        <ul>
                            <li v-for = 'item in threeMenu' :key = 'item.value'>
                                <span
                                :class = '[valueArrChoosed[2] === item.value ? "gaoliang" : ""]'
                                @click.stop = '_threeMenuClickHandler(item.value, item.label)'
                                >{{item.label}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- 设置样式部分 -->
<style lang="less" scoped>
    .inputPopup {
        position: relative;
        height:36px;
        width:210px;
        ::-webkit-scrollbar {
            width: 1px;
            height: 4px;
        }
        ::-webkit-scrollbar-thumb {
            border-radius: 6px;
            background: #2bc9db;
            box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
        }

        ::-webkit-scrollbar-track {
            border-radius: 0;
            background: rgba(0, 0, 0, .1);
            box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
        }
        .inputwrap {
            position: relative;
            height:100%;
            width:100%;
            input {
                width:100%;
                height:100%;
                background:rgba(245,245,247,1);
                border-radius:1px;
                border: none;
                padding: 8px 30px 8px 20px;
                color: #90959D;
                font-size: 14px;
                font-family:PingFangSC-Regular,PingFang SC;
            }
            .falgs {
                position: absolute;
                top: 10px;
                right: 5px;
                font-size: 14px;
                color: #999999;
            }
            .clears {
                position: absolute;
                top: 10px;
                right: 7px;
                width: 15px;
                height: 15px;
                cursor: pointer;
            }
        }
        .detail_fill {
            position: absolute;
            top: 30px;
            left: 0px;
            background: #ffffff;
            width: 100%;
            opacity: 0;
            height: 20px;
        }
        .popwrap {
            z-index: 10000;
            .mtsi-4-block {
                position: absolute;
                top: 50px;
                height: 300px;
                background-color: #fff;
                border: 2px solid #61C2CE;
                box-shadow: 0px 2px 16px 0px rgba(155, 183, 184, 0.5);
                left: 0px;
                z-index: 9999;
                border-radius: 5px;
                &::before {
                    position: absolute;
                    content: "";
                    display: block;
                    width: 0;
                    height: 0;
                    top: -10px;
                    left: 14px;
                    border-bottom: 10px solid #fff;
                    border-left: 10px solid transparent;
                    border-right: 10px solid transparent;
                    z-index: 10;
                }
                &::after {
                    position: absolute;
                    content: "";
                    display: block;
                    width: 0;
                    height: 0;
                    top: -13px;
                    left: 12px;
                    border-bottom: 12px solid #61C2CE;
                    border-left: 12px solid transparent;
                    border-right: 12px solid transparent;
                }
                .mtsi-4-content_w1 {
                    width: 170px;
                }
                .mtsi-4-content_w2 {
                    width: 340px;
                }
                .mtsi-4-content_w3 {
                    width: 510px;
                }
                .mtsi-4-content-left {
                    float: left;
                    width: 170px;
                    z-index: 9999;
                    ul {
                        padding-left: 18px;
                        padding-right: 18px;
                        height: 294px;
                        overflow-y: auto;
                        padding-top: 10px;
                        li {
                            margin-bottom: 5px;
                            span {
                                cursor: pointer;
                                padding: 4px 0px;
                                color: #777;
                                cursor: pointer;
                                border-radius: 2px;
                            }
                            .gaoliang {
                                background-color: #4DC5C3;
                                color: #fff;
                            }
                            span:hover {
                                background-color: #4DC5C3;
                                color: #fff;
                            }
                        }
                    }
                }
                .mtsi-4-content-right {
                    width: 170px;
                    float: left;
                    z-index: 9999;
                    .xuanze_div {
                        text-align: center;
                        img {
                            display: block;
                            width: 80px;
                            height: 41px;
                            margin: 0px auto;
                            margin-top: 60%;
                            margin-bottom: 10px;
                        }
                        span {
                            color: #FFAF14;
                            font-size: 14px;
                        }
                    }
                    ul {
                        padding-left: 18px;
                        padding-right: 18px;
                        height: 294px;
                        overflow-y: auto;
                        padding-top: 10px;
                        li {
                            margin-bottom: 5px;
                            span {
                                cursor: pointer;
                                padding: 4px 0px;
                                color: #777;
                                cursor: pointer;
                                border-radius: 2px;
                            }
                            .gaoliang {
                                background-color: #4DC5C3;
                                color: #fff;
                            }
                            span:hover {
                                background-color: #4DC5C3;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
    }
</style>

<!-- 设置js动作部分 -->
<script>

    // 导入图片模块
    import xuanze from '@/assets/images/xuanze.png';
    import popup_close from '@/assets/images/popup_close.png';

    // 导出模块
    export default {

        // 名称
        name: 'cu-inputpopup',

        // 数据
        data: function() {
            return {

                // 表示图片
                xuanze,
                popup_close,
                // 表示传递信息
                propInfo: [],
                // 表示二级菜单
                twoMenu: [],
                // 表示三级菜单
                threeMenu: [],
                // 表示显示的输入框内容
                inputTitle: '',
                // 表示id集合
                valueArr: [],
                // 只是为了选中用
                valueArrChoosed: [],
                // 表示名称集合
                labelArr: [],
                // 表示弹框显示
                popupShowFlag: false,
                // 表示关闭按钮 显隐
                closedShowFlag: false,
                // 表示被选中id
                choosedId: []
            }
        },

        // 表示参数
        props: {

            /**
             * @author lihh
             * @description 表示传递的数据
             */
            data: {
                type: Array,
                default: function() {
                    return [];
                }
            },

            // 表示input placeholder
            placeholder: {
                type: String,
                default: '职位类别'
            },

            // 表示显示列数
            lineNum: {
                type: String,
                default: '3'
            },

            // 表示是否修改 数据添加不限
            updateFlag: {

                type: String,
                default: '0'
            },

            // 选中属性
            value: {

                type: Array,
                default: function() {
                    return [];
                }
            }
        },

        // 监听
        watch: {

            // 监听传递数据变化
            data: function() {

                // 表示添加不限节点
                const addEle = (datas = []) => {

                    // 判断是否添加不限 添加不限
                    if (this.updateFlag === '1') datas.unshift({label: '不限', value: '-1', children: []});
                    datas.forEach(item => {

                        // 判断是否有children
                        if (item.children && item.children.length > 0) addEle(item.children);
                    });
                    return datas;
                }
                // 浅度赋值数组
                let arr = JSON.parse(JSON.stringify(this.data));
                // 循环遍历 添加不限
                arr.forEach(item => item.children && item.children.length > 0 ? addEle(item.children) : '');

                // 赋值
                this.propInfo = JSON.parse(JSON.stringify(arr));
                // 调用方法
                this._dataSetting();
            },

            // 监听选中id变化
            value: function(val, oldVal) {
                
                // 判断是否是数组
                if (!Array.isArray(val)) return false;
                if (val.length == 0 && oldVal.length === 0) return false;
                // 判断是否有选中的id
                if (val.length <= 0) {

                    this.twoMenu = [];
                    this.threeMenu = [];
                    this.inputTitle = [];
                    this.valueArr = [];
                    this.valueArrChoosed = [];
                    this.labelArr = [];
                    this.choosedId = [];
                    this.$emit('on-change', this.valueArr);
                    return false;
                }
                this.choosedId = val;
                this._dataSetting();
            }
        },

        // 方法
        methods: {

            /**
             * @author lihh
             * @description 数据设定 比如数据的回显
             */
            _dataSetting: function() {

                // 表示二级信息
                let twoItem = [];
                // 表示三级菜单信息
                let threeItem = [];
                // 判断是否需要回显
                if (this.choosedId.length === 0 || this.propInfo.length === 0) return false;

                // 判断是否一级菜单
                if (Number(this.lineNum) >= 1) {

                    // 查询名称
                    let oneName = findName(this.choosedId[0], this.propInfo);
                    this.labelArr = [oneName];
                    this.valueArr = [this.choosedId[0]];
                    this.valueArrChoosed = [this.choosedId[0]];
                }

                // 判断是否二级菜单
                if (Number(this.lineNum) >= 2) {

                    // 获取二级id
                    let twoId = this.choosedId[1];
                    // 判断是否为不限
                    if (twoId.indexOf(',') === -1) {

                        // 查询名称
                        let twoName = findName(this.choosedId[1], twoItem, '2');
                        this.labelArr.push(twoName);
                        this.valueArr.push(this.choosedId[1]);
                        this.valueArrChoosed.push(this.choosedId[1]);
                    } else {

                        this.labelArr.push('不限');
                        // 获取所有的id
                        let ids = [];
                        twoItem.forEach(item => ids.push(item.value));
                        this.valueArr.push(ids.join(','));
                        this.valueArrChoosed.push('-1');
                    }
                    this.twoMenu = twoItem;
                }

                // 判断是否三级菜单
                if (Number(this.lineNum) >= 3) {

                    // 如果二级是不限 三级不显示
                    if (this.valueArrChoosed[1] === '-1') return false;

                    // 获取三级id
                    let threeId = this.choosedId[2];
                    // 判断是否为不限
                    if (threeId.indexOf(',') === -1) {

                        // 查询名称
                        let threeName = findName(this.choosedId[2], threeItem, '3');
                        this.labelArr.push(threeName);
                        this.valueArr.push(this.choosedId[2]);
                        this.valueArrChoosed.push(this.choosedId[2]);
                    } else {

                        this.labelArr.push('不限');
                        // 获取所有的id
                        let ids = [];
                        threeItem.forEach(item => ids.push(item.value));
                        this.valueArr.push(ids.join(','));
                        this.valueArrChoosed.push('-1');
                    }
                    this.threeMenu = threeItem;
                }
                this.inputTitle = this.labelArr.join('/');

                /**
                 * @author lihh
                 * @description 查询名称
                 * @param value 表示需要查询的值
                 * @param data 表示需要遍历的数据
                 * @param falg 表示从几级开始查询
                 */
                function findName(value, data, flag = '1') {

                    for (let i = 0; i < data.length; i ++) {
                        let item = data[i];

                        // 判断value 是否一致
                        if (item.value === value) {

                            // 设置二级或是三级菜单信息
                            if (flag === '1') {
                                twoItem = item.children && item.children.length > 0 ? item.children : [];
                            } else if (flag === '2') {
                                threeItem = item.children && item.children.length > 0 ? item.children : [];
                            }
                            return item.label;
                        }
                    }
                }
            },

            /**
             * @author lihh
             * @description 表示关闭弹框
             */
            _handlerClose: function() {

                this.popupShowFlag = false;
            },

            /**
             * @author lihh
             * @description 表示清除数据
             */
            _clearData: function() {

                // 判断是否为空
                if (this.valueArr.length === 0) return false;

                // 进行数据清空
                this.inputTitle = '';
                this.valueArr = [];
                this.twoMenu = [];
                this.threeMenu = [];
                this.valueArrChoosed = [];
                this.labelArr = [];
                this.popupShowFlag = false;
                this.$emit('on-change', this.valueArr);
                window.stack = [];
                this.$attrs.value = this.valueArr;
            },

            /**
             * @author lihh
             * @description 表示一级菜单点击事件
             * @param value 表示选中的值
             * @param name 表示选中的名称
             * @param children 表示子类
             */
            _oneMenuClickHandler: function(value, name, children) {

                // 设置显示内容
                this.labelArr = [name];
                this.valueArr = [value];
                this.valueArrChoosed = JSON.parse(JSON.stringify(this.valueArr));

                // 判断一级菜单是否为不限
                if (value == '' && name == '不限') {

                    this.inputTitle = '不限';

                    // 参数传递给父类
                    this.$emit('on-change', []);
                    window.stack = [];
                    this.$attrs.value = [];
                    this.popupShowFlag = false;
                    return false;
                }

                // 判断是否显示1列 选择器
                if (Number(this.lineNum) === 1 || (!children || children.length == 0)) {

                    this.inputTitle = this.labelArr.join('/');

                    // 参数传递给父类
                    this.$emit('on-change', this.valueArr);
                    window.stack = [];
                    this.$attrs.value = this.valueArr;
                    this.popupShowFlag = false;
                    return false;
                }

                // 二级菜单
                this.twoMenu = children;
                this.threeMenu = [];
            },

            /**
             * @author lihh
             * @description 表示二级菜单点击事件
             * @param value 表示选中的值
             * @param name 表示选中的名称
             * @param children 表示子类
             */
            _twoMenuClickHandler: function(value, name, children) {

                this.valueArrChoosed.splice(1, 2, value);
                // 判断是否为不限 获取所有二级菜单
                if (value === '-1') {

                    // 临时二级菜单
                    let tempArr = [];
                    this.twoMenu.forEach(item => item.value !== '-1' ? tempArr.push(item.value) : '');
                    value = tempArr.join(',');
                }

                // 设置显示内容
                this.labelArr.splice(1, 2, name);
                this.valueArr.splice(1, 2, value);
                // 判断是否显示2列 选择器
                if (Number(this.lineNum) === 2 || value === '-1'
                     || (!children || children.length == 0)) {

                    this.inputTitle = this.labelArr.join('/');

                    // 参数传递给父类
                    this.$emit('on-change', this.valueArr);
                    window.stack = [];
                    this.$attrs.value = this.valueArr;
                    this.popupShowFlag = false;
                    return false;
                }

                // 三级菜单
                this.threeMenu = children;
            },

            /**
             * @author lihh
             * @description 表示三级菜单点击事件
             * @param value 表示选中的值
             * @param name 表示选中的名称
             */
            _threeMenuClickHandler: function(value, name) {

                this.valueArrChoosed.splice(2, 1, value);
                // 判断是否为不限 获取所有二级菜单
                if (value === '-1') {

                    // 临时二级菜单
                    let tempArr = [];
                    this.threeMenu.forEach(item => item.value !== '-1' ? tempArr.push(item.value) : '');
                    value = tempArr.join(',');

                    // 三级选择不限的时候  id字符串后拼接二级菜单id
                    if (this.valueArrChoosed.length >= 2) value = `${value},${this.valueArrChoosed[1]}`;
                }

                // 设置显示内容
                value === '-1' ? this.labelArr.splice(2, 1) : this.labelArr.splice(2, 1, name);
                this.valueArr.splice(2, 1, value);
                this.inputTitle = this.labelArr.join('/');

                // 参数传递给父类
                this.$emit('on-change', this.valueArr);
                window.stack = [];
                this.$attrs.value = this.valueArr;
                this.popupShowFlag = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/packages/InputPopup/CuInputPopup/Cu-InputPopup.vue